import React, { 
    useState, 
    useEffect 
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import dayjs from 'dayjs';
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Form,
    Select,
    DatePicker,
    Table,
    InputNumber,
    Space,
    Tag,
    Modal,
} from 'antd';
import { 
    ArrowBack,
} from '@mui/icons-material';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { 
    useNavigate, 
    useParams 
} from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Item } = Form;
const { confirm } = Modal;

const ViewReading = () => {
    const navigate = useNavigate()
    const { callPost, loading } = usePostRequest(()=>{
        navigate(-1)
    });
    const [isLoading, setIsLoading] = useState(false)
    // const [isDisabled, setIsDisabled] = useState(true)
    const [meterDetails, setMeterDetails] = useState([])
    const [withPaid, setWithPaid] = useState('')
    const [readingDetails, setReadingDetails] = useState([])
    const [propertyData, setPropertyData] = useState([])
    const [propertyId, setPropertyId] = useState([])

    const [viewMeterForm] = Form.useForm();
    const { id, type } = useParams();
    async function fetchMeterReadingDetails() {
        setIsLoading(true)
        const response = await UseGetRequest("meter_readings/get_meter_reading_details", {meter_reading_id: id, property_id: propertyId});
        if(response?.data) {
            const meter_data = response?.data?.data;
            setWithPaid(response?.data?.with_paid)
            setMeterDetails(meter_data?.meter_reading_details);
            viewMeterForm.setFieldsValue({
                date_range: [
                    dayjs(meter_data.date_from, 'YYYY/MM/DD'),
                    dayjs(meter_data.date_to, 'YYYY/MM/DD')
                ],
                property: meter_data.property_id,
                normal_rate: meter_data.normal_rate || 0.00,
                emergency_rate: meter_data.emergency_rate || 0.00,
            });
        } else {
            setMeterDetails([])
        }

        setIsLoading(false)
    }
    React.useEffect(() => {
        fetchMeterReadingDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    const meterValues = viewMeterForm.getFieldsValue();
    // const values = Form.useWatch([], viewMeterForm);
    // React.useEffect(() => {
    //     viewMeterForm.validateFields({
    //     validateOnly: true,
    //         }).then(() => {
    //             // fetchMeterReadingDetails(id)
    //             setIsDisabled(false)
    //         },
    //         () => {
    //             // fetchMeterReadingDetails('')
    //             setIsDisabled(true)
    //         },
    //     );
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [values, viewMeterForm]);

    const defaultColumnsAlfresco = [
        {
          title: 'Tradename',
          dataIndex: 'trade_name',
        },
        {
          title: 'Business Name',
          dataIndex: 'business_name',
        },
        {
          title: 'Previous Reading',
          dataIndex: 'previous_meter',
          align: 'right',
        },
        {
            title: 'Current Reading',
            dataIndex: 'current_meter',
            align: 'right',
            render: (_, record, index) => {
              return (
                <InputNumber  
                    min={record.previous_meter} 
                    value={record.current_meter}
                    style={{ width: '100%' }} 
                    disabled={record.status === "paid"}
                    onChange={(e) => handleAddMeterDetails(index,"current_meter",e, record)}
                />
              );
            },
        },
        {
          title: 'Normal Consumption',
          dataIndex: 'normal_consumption',
          align: 'right',
          render: (_, record, index) => {
            return (
                <InputNumber 
                    style={{ width: '100%' }} 
                    value={record?.normal_consumption}
                    disabled={record.status === "paid"}
                    onChange={(e) => handleAddMeterDetails(index, "normal_consumption", e)}
                />
            );
          },
        },
        {
          title: 'Normal Fee',
          dataIndex: 'normal_fee',
          align: 'right',
          ender: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Emergency Consumption',
          dataIndex: 'emergency_consumption',
          align: 'right',
          ender: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Emergency Fee',
          dataIndex: 'emergency_fee',
          align: 'right',
          ender: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Total Fee',
          dataIndex: 'total_fee',
          align: 'right',
          ender: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Status',
          dataIndex: 'status',
          align: 'center',

          render: status => {
            let color;
            switch (status) {
              case 'paid':
                color = 'green';
                break;
              case 'unpaid':
                color = 'volcano';
                break;
              default:
                color = 'geekblue';
                break;
            }
            return <Tag color={color}>{status.toUpperCase()}</Tag>;
          },
        },
    ];
    const handleAddMeterDetails = (key, name, e, data) => {
        if(name === "current_meter"){
            setMeterDetails(prevState => {
                const newState = [...prevState];
                newState[key] = { 
    
                    ...newState[key], 
                    [name]: e,
                    normal_consumption: e - data.previous_meter
    
                };
                return newState;
            });
        } else {
            setMeterDetails(prevState => {
                const newState = [...prevState];
                newState[key] = { 
    
                    ...newState[key], 
                    normal_consumption: e,    
                };
                return newState;
            });
        }
    };
    
    const isPaid = (meter) => {
        return meter.some(item => item.status === 'paid');
    };

    const generateReading = (meter_rates, meterValues) => {
        const meter_data = meter_rates?.map((meter) => {
            var normFee = parseFloat(meter.normal_consumption) * parseFloat(meterValues.normal_rate || 0);
            var empCons = ((parseFloat(meter.current_meter) - parseFloat(meter.previous_meter)) - parseFloat(meter.normal_consumption));
            var empFee = (parseFloat(meterValues.emergency_rate || 0) *  parseFloat(empCons));
            var totalFee = (parseFloat(normFee) + parseFloat(empFee));
    
            return {
                id: meter.id,
                business_name: meter.business_name || "",
                trade_name: meter.trade_name || "",
                status: meter.status || "",
                previous_meter: meter.previous_meter || 0.00,
                current_meter: meter.current_meter || 0.00,
                normal_consumption: meter.normal_consumption || 0.00,
                normal_rate: meterValues.normal_rate || 0.00,
                emergency_rate: meterValues.emergency_rate || 0.00,
                date_from: meterValues.date_range[0].format('YYYY-MM-DD'),
                date_to: meterValues.date_range[1].format('YYYY-MM-DD'),
                normal_fee: (normFee && normFee >= 0) ? normFee : 0.00,
                emergency_consumption:  (empCons && empCons >= 0) ? empCons : 0.00,
                emergency_fee: (empFee && empFee >= 0) ? empFee : 0.00,
                total_fee: (totalFee && totalFee >= 0) ? totalFee : 0.00,
            };
        });
    
        return meter_data;
    };
    

    const reading_data = generateReading(meterDetails, meterValues)

    async function fetchPropertyData  () {
        // setIsLoading(true)

        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }
    
        // setIsLoading(false);
    }

    async function fetchLastReading() {
        // setIsLoading(true)
        const response = await UseGetRequest("meter_readings/get_last_reading_by_property", {utility_type: type, property_id: propertyId});
        if (response?.data) {
            const details = response?.data?.data
            setReadingDetails(details);
            viewMeterForm.setFieldsValue({
                date_range: [
                    dayjs(details.date_to, 'YYYY/MM/DD').add(1, 'day'),
                    undefined
                    // dayjs(details.date_to, 'YYYY/MM/DD'),
                ],
            });

        } else {
          setReadingDetails([])
        }
    
        // setIsLoading(false);
    }

    const disabledDate = current => {
        const dateToDisable = dayjs(readingDetails.date_to, 'YYYY/MM/DD').add(1, 'day');
        return current && current.isBefore(dateToDisable, 'day');
    };


    const handlePropertyType = (value) => {
        setPropertyId(value)
    };
    const handleAddReading = () => {
        try{  
    
            const data = {
                meter_reading_id: id,
                date_from: meterValues.date_range[0].format('YYYY-MM-DD'),
                date_to: meterValues.date_range[1].format('YYYY-MM-DD'),
                utility_type: type,
                normal_rate: meterValues.normal_rate || 0.00,
                emergency_rate: meterValues.emergency_rate || 0.00,

                meter_reading_detail_id: reading_data.map((item)=>item.id),
                previous_meter: reading_data.map((item)=>item.previous_meter),
                current_meter: reading_data.map((item)=>item.current_meter),
                normal_consumption: reading_data.map((item)=>item.normal_consumption),
                normal_fee: reading_data.map((item)=>item.normal_fee),
                emergency_consumption: reading_data.map((item)=>item.emergency_consumption),
                emergency_fee: reading_data.map((item)=>item.emergency_fee),
                total_fee: reading_data.map((item)=>item.total_fee),
            }
        
            var finalValues = Object.entries(data).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "meter_readings/update", 
                finalValues,
                true,
            );
        }catch (error) {
          toast.error('Validation Failed:', error);
        };
    };

    const showDeleteConfirm = (id) => {
        confirm({
          title: 'Do you want to permanently remove this Reading?',
          icon: <ExclamationCircleFilled style={{ color: 'red' }}/>,
          content: 'This action cannot be undone.',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          confirmLoading: loading,
          onOk() {
            callPost(
                "meter_readings/delete", 
                {meter_reading_id: id},
                false,
            ); 
          },
        });
    };

    useEffect(() => {
        fetchPropertyData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if(propertyId){
            fetchLastReading();
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row className='p-2'>
                    <Col span={24} className='header-container p-4'>
                        <Space>
                            <ArrowBack className='cursor' onClick={() => navigate(-1)}/>
                            VIEW READING
                        </Space>
                    </Col>
                </Row>
                <Row className='p-2'>
                    <Col span={24}>
                        <Form
                            form={viewMeterForm}
                            layout="vertical"
                        >
                            <Row className='mx-3 responsive-inline responsive-width'>
                                <Col span={4} className='pe-4'>
                                    <Item
                                        label="Property"
                                        name="property"
                                        rules={[{ required: true, message: 'Please select a date from' }]}
                                        className='reading-input'
                                    >
                                       <Select 
                                        onChange={handlePropertyType} 
                                        placeholder="Select a property"
                                        disabled
                                    >
                                        {propertyData.map((option, index) => (
                                            <Option key={index} value={option.id}>{option.name}</Option>
                                        ))}
                                    </Select>
                                    </Item>
                                </Col>
                                <Col span={5} className='pe-4'>
                                    <Item
                                        label="Date Range"
                                        name="date_range"
                                        rules={[{ required: true, message: 'Please select a date from' }]}
                                        className='reading-input'
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            placeholder={['Date From', 'Date To']}
                                            format={'YYYY/MM/DD'}
                                            disabledDate={disabledDate}
                                            disabled={true}
                                            allowClear={false}  
                                        />
                                    </Item>
                                </Col>
                                <Col span={3} className='pe-4'>
                                    <Item
                                        label="Normal Rate"
                                        name="normal_rate"
                                        rules={[{ required: true, message: 'Please enter your Normal Rate!' }]}
                                        className='reading-input'
                                    >
                                        <InputNumber 
                                            style={{width:'100%'}}
                                            disabled={isPaid(meterDetails)}
                                        />
                                    </Item>
                                </Col>
                                <Col span={3} className='pe-4'>
                                    <Item
                                        label="Emergency Rate"
                                        name="emergency_rate"
                                        // rules={[{ required: true, message: 'Please enter your Emergency Rate!' }]}
                                        className='reading-input'
                                    >
                                        <InputNumber 
                                            style={{width:'100%'}}
                                            disabled={isPaid(meterDetails)}
                                        />
                                    </Item>
                                </Col>
                                <Space className='pe-4'>
                                    <Button 
                                        disabled={withPaid === 1}
                                        onClick={() => showDeleteConfirm(id)}
                                        className='cancel-color btn-header'
                                        loading={loading}
                                    >
                                        Delete Reading
                                    </Button>
                                    <Button 
                                        type="primary" 
                                        // disabled={isDisabled}
                                        onClick={() => handleAddReading()}
                                        loading={loading}
                                        disabled={isPaid(meterDetails)}
                                    >
                                        Submit
                                    </Button>
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table
                            rowClassName={() => 'editable-row'}
                            bordered
                            dataSource={reading_data}
                            columns={defaultColumnsAlfresco}
                            loading={isLoading}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default ViewReading
